import cumulative from './cumulativeDeaths.svg'
import fishCount from './fishCount.svg'
import FIshHistoryImage from './FishHistoryIcon.svg'
export const cumulativeIcon = cumulative
export const fishCountIcon = fishCount
export const FIshHistoryIcon = FIshHistoryImage
